import * as React from 'react';
import { useMutation, useQuery } from '@apollo/client';
import {
  deliveryTokenQuery,
  deliveryTokensForUserQuery,
} from '../../graphql/queries';
import moment from 'moment';
import { useState } from 'react';
import i18n from '@/utils/i18n';
import { EditItem } from '../../components/Layout';
import { ButtonWithConfirmation } from '../../components/ButtonWithConfirmation';
import { deleteDeliveryTokenMutation } from '../../graphql/mutations';

const momentFormat = 'HH:mm - DD.MM.YYYY';

export function UserDeliveryTokens(params: {
  externalPickpackId: string | undefined | null;
}) {
  const { externalPickpackId } = params;

  const [searchTerm, setSearchTerm] = useState('');
  const {
    data: deliveryTokenSearchData = { deliveryToken: null },
    error: searchError,
    loading: searching,
  } = useQuery(deliveryTokenQuery, {
    fetchPolicy: 'no-cache',
    skip: !externalPickpackId || !searchTerm,
    variables: { delivery_token: searchTerm.toUpperCase() },
  });
  const { deliveryToken: deliveryTokenBySearch }: any = deliveryTokenSearchData;

  const { data = { deliveryTokensForUser: [] }, loading } = useQuery(
    deliveryTokensForUserQuery,
    {
      fetchPolicy: 'cache-and-network',
      skip: !externalPickpackId,
      variables: { user_id: externalPickpackId },
    },
  );

  const { deliveryTokensForUser } = data;
  console.log(deliveryTokensForUser);

  const [deleteDeliveryToken] = useMutation(deleteDeliveryTokenMutation);

  function deleteToken(id: string) {
    deleteDeliveryToken({
      variables: {
        id,
      },
      refetchQueries: [
        {
          query: deliveryTokensForUserQuery,
          variables: { user_id: externalPickpackId },
        },
      ],
      awaitRefetchQueries: true,
    });
  }

  if (!externalPickpackId) return <p>No pickpack id set</p>;

  return (
    <div>
      <table className="table-striped table">
        <thead>
          <tr>
            <th>Token</th>
            <th>created at</th>
            <th>expires in</th>
            <th>delete</th>
          </tr>
        </thead>
        <tbody>
          {deliveryTokensForUser.map((deliveryToken: any) => {
            const validUntilMoment = moment.unix(deliveryToken.ttl);

            return (
              <tr key={deliveryToken.id}>
                <td>V-{deliveryToken.id}</td>
                <td>{moment(deliveryToken.created_at).format(momentFormat)}</td>
                <td title={validUntilMoment.format(momentFormat)}>
                  {validUntilMoment.fromNow()}
                </td>
                <td>
                  <ButtonWithConfirmation
                    onConfirmed={() => deleteToken(deliveryToken.id)}
                    confirmationText={`Are you really sure you want to delete token ${deliveryToken.id}`}
                  >
                    Delete
                  </ButtonWithConfirmation>
                </td>
              </tr>
            );
          })}
          {loading && (
            <tr>
              <td colSpan={4}>loading...</td>
            </tr>
          )}
          {!loading && deliveryTokensForUser.length === 0 && (
            <tr>
              <td colSpan={4}>no delivery tokens found for this user</td>
            </tr>
          )}
        </tbody>
      </table>

      <br />
      <br />

      <EditItem title={i18n.t('Users:findUserByDeliveryToken')}>
        <div className="input-group mb-3">
          <div className="input-group-text">V-</div>
          <input
            type="text"
            className="form-control"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value.toUpperCase())}
            placeholder="AAA11"
          />
        </div>
        {searching && <p>Searching...</p>}
        {searchError && searchError.graphQLErrors.join(',')}
        {!searching && !searchError && deliveryTokenBySearch && (
          <a href={'/users/' + deliveryTokenBySearch.vytal_user_id}>
            User {deliveryTokenBySearch.user_id}
          </a>
        )}
      </EditItem>
    </div>
  );
}
